import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './NoSidebar.module.scss';

const NoSidebar = (Container) => {
    const { displayName } = Container;

    const Wrapper = ({ containerName = '', ...restProps }) => {
        const name = containerName ? containerName : displayName;
        const classes = classNames(s.Root, [s[`Root--${name}`]]);
        return (
            <div className={classes}>
                <div className={s.Document} role="document">
                    <main className={s.Main} id="mainContent">
                        <Container {...restProps} />
                    </main>
                </div>
            </div>
        );
    };

    Wrapper.propTypes = {
        containerName: PropTypes.string,
    };

    return Wrapper;
};

NoSidebar.propTypes = {
    displayName: PropTypes.string,
};

export default NoSidebar;
